var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCalendar2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91667 1.5V3.25M12.0833 1.5V3.25M1 13.75V5C1 4.0335 1.7835 3.25 2.75 3.25H13.25C14.2165 3.25 15 4.0335 15 5V13.75M1 13.75C1 14.7165 1.7835 15.5 2.75 15.5H13.25C14.2165 15.5 15 14.7165 15 13.75M1 13.75V7.91667C1 6.95017 1.7835 6.16667 2.75 6.16667H13.25C14.2165 6.16667 15 6.95017 15 7.91667V13.75M8 9.08333H8.00583V9.08917H8V9.08333ZM8 10.8333H8.00583V10.8392H8V10.8333ZM8 12.5833H8.00583V12.5892H8V12.5833ZM6.25 10.8333H6.25583V10.8392H6.25V10.8333ZM6.25 12.5833H6.25583V12.5892H6.25V12.5833ZM4.5 10.8333H4.50583V10.8392H4.5V10.8333ZM4.5 12.5833H4.50583V12.5892H4.5V12.5833ZM9.75 9.08333H9.75583V9.08917H9.75V9.08333ZM9.75 10.8333H9.75583V10.8392H9.75V10.8333ZM9.75 12.5833H9.75583V12.5892H9.75V12.5833ZM11.5 9.08333H11.5058V9.08917H11.5V9.08333ZM11.5 10.8333H11.5058V10.8392H11.5V10.8333Z",
    stroke: "#7D7D7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendar2);
export default __webpack_public_path__ + "static/media/ic-calendar2.a0feec8183f30040c3cbedfe331fab38.svg";
export { ForwardRef as ReactComponent };